import { generateRandomName } from '@blaze-runtime/engine-util';
import { NAMESPACE_LENGTH } from '@blaze-shared/workflow-domain';

import { type CanvasElementInnerId } from './canvas-element';
import { type CanvasElementId, type CanvasNamespaceId } from './canvas-element-id';

export const ROOT_ELEMENT_INNER_ID: CanvasElementInnerId = 0;

/**
 * Generate root elementId from namespaceId
 */
export function getRootElementId(namespaceId: CanvasNamespaceId): CanvasElementId {
  return namespaceId + '_' + ROOT_ELEMENT_INNER_ID;
}

/**
 * The root of the currently rendered page. Roots of partial views (Header, Sidebar, Bottombar)
 * are rendered inside it and are not page roots.
 */
export function isPageRootId(
  elementId: CanvasElementId | undefined,
  pageId: CanvasNamespaceId | undefined,
): boolean {
  return !!elementId && !!pageId && elementId === getRootElementId(pageId);
}

/**
 * Generate a new element id within provided namespace
 * @param namespaceId the id of the namespace
 * @returns the id of the element
 */
export function getNewElementId(namespaceId: CanvasNamespaceId): CanvasElementId {
  const newId = crypto.randomUUID();
  return namespaceId + '_' + newId + '-' + generateRandomName();
}

/**
 * Slices the namespaceId from the elementId
 */
export function getNamespaceId(elementId: CanvasElementId): CanvasNamespaceId {
  return elementId.slice(0, NAMESPACE_LENGTH);
}
